import React from 'react'

const ECOSYSTEM_SIBLINGS = [
  {
    name: 'UrLawyers',
    tagline: 'Consult Verified Lawyers',
    href: 'https://www.urlawyers.in',
    logo: 'https://www.mgfintech.com/assets/images/products/urlawyers.png',
    hoverBorder: 'hover:border-blue-500',
    accent: 'text-blue-400',
  },
  {
    name: 'OPTOKART',
    tagline: 'Eyewear in 3–24 Hours',
    href: 'https://www.optokart.com',
    logo: 'https://www.mgfintech.com/assets/images/products/optokart.png',
    hoverBorder: 'hover:border-cyan-500',
    accent: 'text-cyan-400',
  },
  {
    name: '10D Stores',
    tagline: 'Hyperlocal Store Management',
    href: 'https://www.10dstores.com',
    logo: 'https://www.mgfintech.com/assets/images/products/10dstores.png',
    hoverBorder: 'hover:border-green-500',
    accent: 'text-green-400',
  },
  {
    name: 'BRESA',
    tagline: 'Real Estate Aggregator',
    href: 'https://www.bresa.in',
    logo: 'https://www.mgfintech.com/assets/images/products/bresa.png',
    hoverBorder: 'hover:border-purple-500',
    accent: 'text-purple-400',
  },
  {
    name: 'NetVid',
    tagline: 'Decentralized Video Platform',
    href: 'https://www.netvid.in',
    logo: 'https://www.mgfintech.com/assets/images/products/netvid.png',
    hoverBorder: 'hover:border-violet-500',
    accent: 'text-violet-400',
  },
  {
    name: 'Mevorides',
    tagline: 'Electric Vehicle Ride Sharing',
    href: 'https://www.mevorides.com',
    logo: 'https://www.mgfintech.com/assets/images/products/mevorides.jpg',
    hoverBorder: 'hover:border-emerald-500',
    accent: 'text-emerald-400',
  },
]

export default function EcosystemProductsSection({ titleClass = 'text-light font-bold mb-6 tracking-wide uppercase text-sm' }) {
  return (
    <section className="border-t border-dark-border py-16">
      <div className="container-custom">
        <h3 className={`${titleClass} text-center !text-lg !normal-case !tracking-normal mb-2`}>
          Other Products by{' '}
          <a href="https://www.mgfintech.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
            MG Fintech
          </a>
        </h3>
        <p className="text-light-muted text-center text-sm mb-10 max-w-xl mx-auto">
          Explore our ecosystem of websites and apps
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ECOSYSTEM_SIBLINGS.map((product) => (
            <a
              key={product.name}
              href={product.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`group block p-6 rounded-2xl bg-dark-card border border-dark-border ${product.hoverBorder} transition-all hover:shadow-lg`}
            >
              <div className="h-14 flex items-center justify-center mb-4 bg-white/5 rounded-xl p-2">
                <img src={product.logo} alt={product.name} className="max-h-full max-w-full object-contain" loading="lazy" />
              </div>
              <h4 className="text-light font-semibold text-lg">{product.name}</h4>
              <p className="text-light-muted text-sm mt-1">{product.tagline}</p>
              <span className={`inline-block mt-4 text-sm font-medium ${product.accent}`}>Visit website →</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
